import { saveAs } from "file-saver";
import { rmsClient } from "@/shared/api/clients";

/**
 * One filename convention for every report-PDF download (previously three:
 * incident-report-{date}, incident-information-{id}, incident-{id}).
 * The report id gives traceability; the date preserves the old
 * Confirmation-page convention.
 */
export function reportPdfFilename(reportId: string, now: Date = new Date()): string {
  const date = now.toISOString().split("T")[0];
  return `incident-report-${reportId}-${date}.pdf`;
}

/**
 * Downloads the report PDF and hands it to the browser via file-saver.
 * Throws on failure — callers own their toast/error handling.
 */
export async function downloadReportPdf(opts: {
  reportId: string;
  languageCode?: string;
}): Promise<void> {
  const { reportId, languageCode = "en" } = opts;
  const response = await rmsClient.get("/report/download", {
    params: { reportId, languageCode },
    responseType: "blob",
    headers: { Accept: "application/pdf" },
  });
  saveAs(new Blob([response.data], { type: "application/pdf" }), reportPdfFilename(reportId));
}
